import React from 'react'
import styled, { css } from 'styled-components'

const width = '16'
const height = '14'
const viewBox = '0 0 16 14'

const getDimensions = () => ({
  height,
  width
})

const getDimensionsCss = () => css`
  width: ${width}px;
  height: ${height}px;
`

const Image = styled.svg`
  ${({ noStyles }) => (!noStyles ? getDimensionsCss() : null)}
`

const defaultProps = {
  children: [
    <path
      fill="#FFF"
      fillRule="evenodd"
      d="M16 1.657a6.178 6.178 0 0 1-1.885.557A3.507 3.507 0 0 0 15.56.259a6.287 6.287 0 0 1-2.086.856C12.876.43 12.022 0 11.077 0 9.265 0 7.796 1.583 7.796 3.534c0 .277.028.546.084.805C5.152 4.191 2.734 2.786 1.114.645A3.74 3.74 0 0 0 .67 2.424c0 1.225.579 2.307 1.46 2.941a3.108 3.108 0 0 1-1.488-.44v.043c0 1.713 1.132 3.142 2.635 3.465a3.042 3.042 0 0 1-1.483.062c.418 1.404 1.63 2.426 3.066 2.453-1.123.949-2.54 1.514-4.077 1.514A6.26 6.26 0 0 1 0 12.413 8.832 8.832 0 0 0 5.032 14c6.038 0 9.34-5.385 9.34-10.055 0-.154-.003-.308-.009-.458A6.947 6.947 0 0 0 16 1.657"
      key="key-0"
    />
  ],
  viewBox
}

export default Object.assign(Image, {
  getDimensions,
  getDimensionsCss,
  defaultProps,
  displayName: 'LogoSocialTwitter'
})
